// Styles pour les notifications react-notification-system
export const style = {
    Wrapper: {},
    Containers: {
        DefaultStyle: {
            zIndex: 11000,
            padding: '10px'
        },
        tl: { top: '0px', left: '0px', width: '100%', padding: '0' },
        tc: { top: '0px', width: '100%', padding: '0' }
    },
    NotificationItem: {
        DefaultStyle: {
            borderRadius: '4px',
            fontSize: '14px',
            margin: '10px',
            padding: '12px 18px',
            position: 'relative',
            width: 'auto',
            display: 'grid',
            gridTemplateColumns: 'auto 1fr auto',
            alignItems: 'center',
            gap: '12px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.12)',
            transition: 'all 0.5s ease-in-out'
        },
        success: {
            color: '#ffffff',
            backgroundColor: '#4caf50',
            borderTop: 0
        },
        error: {
            color: '#ffffff',
            backgroundColor: '#f44336',
            borderTop: 0
        },
        warning: {
            color: '#ffffff',
            backgroundColor: '#ff9800',
            borderTop: 0
        },
        info: {
            color: '#ffffff',
            backgroundColor: '#2196f3',
            borderTop: 0
        }
    },
    Title: {
        DefaultStyle: {
            display: 'flex',
            alignItems: 'center',
            fontSize: '20px',
            margin: 0,
            padding: 0
        }
    },
    MessageWrapper: {
        DefaultStyle: {
            margin: 0,
            padding: 0
        }
    },
    Dismiss: {
        DefaultStyle: {
            cursor: 'pointer',
            fontSize: '18px',
            padding: '6px',
            position: 'relative',
            top: 'auto',
            right: 'auto',
            lineHeight: 1,
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
        },
        success: {
            color: '#ffffff'
        },
        error: {
            color: '#ffffff'
        },
        warning: {
            color: '#ffffff'
        },
        info: {
            color: '#ffffff'
        }
    },
    Action: {
        DefaultStyle: {
            background: '#ffffff',
            borderRadius: '2px',
            padding: '6px 12px',
            fontWeight: 'bold',
            margin: '10px 0 0 0',
            border: 0
        },
        success: {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            color: '#ffffff'
        },
        error: {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            color: '#ffffff'
        },
        warning: {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            color: '#ffffff'
        },
        info: {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            color: '#ffffff'
        }
    }
};

export default style;